import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { CargoItemService } from "./cargo-item.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { Filter, FilterModel } from "src/app/core/models/filter";
import { AuthService } from "src/app/core/services/authentication.service";
import { User } from "src/app/core/interfaces/user";
import { Global } from "src/app/core/resources/global";
import { Cargo } from "src/app/core/interfaces/cargo";
import { Utils } from "src/app/core/resources/utils";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { VehiclesService } from "../../administration/vehicles/list-vehicles.service";
import { Permission } from "src/app/core/resources/permission";
import { PermissionRole } from "src/app/core/resources/permission-role";
import { Titles } from "src/app/core/resources/titles";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { DateFormatPipe } from "src/app/core/pipe/dateFormat.pipe";
import { HttpErrorResponse } from "@angular/common/http";
import { Dialog } from "src/app/core/resources/dialog";
import { FreightListService } from "../cargo-list/cargo-list.service";
import { SummaryAdditionalCostCargoComponent } from "../summary-additional-cost-cargo/summary-additional-cost-cargo.component";
import { DetailVehicleComponent } from "../../administration/vehicles/detail-vehicle/detail-vehicle.component";
import { Vehicle } from "src/app/core/interfaces/vehicle";
import { UserFormComponent } from "../../administration/admin-users/user-form/user-form.component";
import { AdminUsersService } from "../../administration/admin-users/admin-users.service";
import { CargoManager } from "src/app/core/managers/cargo.manager";
import { ExpirationDateContainerEnum } from "src/app/core/enums/expirationDateContainer.enum";
import { UpdateAdditionalCostCargoComponent } from "../cargo-detail/components/update-additional-cost-cargo/update-additional-cost-cargo.component";
import { ExpirationDateDTAEnum } from "src/app/core/enums/expirationDateDTA.enum";
import { RolesService } from "../../administration/roles/roles.service";
import { Role } from "src/app/core/interfaces/role";
import { AssignVehicleCargoComponent } from "../assign-vehicle-cargo/assign-vehicle-cargo.component";
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { ReceivableService } from "../../administration/receivable/receivable.service";
import { ServiceMessages } from "src/app/core/messages/service-messages.enum";
import { SummaryBalanceComponent } from "../summary-balance/summary-balance.component";
import { AmountsCargoEnum } from "src/app/core/enums/amountsCargo.enum";
import { catchError } from "rxjs/operators";
import { forkJoin, Subscription, throwError } from "rxjs";
import { DateManager } from "src/app/core/managers/date.manager";
import { ColorService } from "src/app/core/services/color.service";
import { CargoShippingCostDialogComponent } from "../cargo-shipping-cost-dialog/cargo-shipping-cost-dialog.component";
import { ExpirationBillEnum, ExpirationDriverPaymentEnum } from "src/app/core/enums/expirationBill.enum";
import { environment } from "src/environments/environment";
import { CargoStateEnum } from "src/app/core/enums/cargoState.enum";
import { CargoService } from "src/app/core/services/cargo.service";
import { BasicCompany } from "src/app/core/interfaces/basicCompany";
import { Company } from "src/app/core/interfaces/company";
import { AccountService } from "../../account/account.service";
import { TravelExpensesService } from "src/app/core/services/travel-expenses.service";
import { CatalogItem } from "src/app/core/interfaces/catalogItem";
import { ApprovalStateEnum, TravelExpense, TravelExpenseDetail } from "src/app/core/interfaces/travel-expense";
import { LastPointLocation } from "src/app/core/interfaces/lastPointLocation";
import { LegalizeTravelExpensesComponent } from "../legalize-travel-expenses/legalize-travel-expenses.component";
import { Companies } from "src/app/core/resources/companies";
import { TRIP_TYPES } from "src/app/core/enums/tripTypes.enum";
import { ServiceType } from "src/app/core/interfaces/serviceType";
import { TurnMatch } from "src/app/core/interfaces/turnMatch";
import { AddressCargo } from "src/app/core/interfaces/addressCargo";
import { Destination } from "src/app/core/interfaces/destination";
import { CargoPaymentsService } from "src/app/core/services/cargo-payments.service";
import { CargoPayment, CargoPaymentDetail } from "src/app/core/interfaces/cargoPayment";
import { VehicleInspect } from "src/app/core/interfaces/vehicleInspect";
import { CARGO_TRAVEL_EXPENSES_LAZY, resolveCargoRealtime } from "../cargo-list/cargo-realtime.config";
import { CompaniesService } from "../../administration/companies/list-companies.service";
import { SettingId } from 'src/app/core/interfaces/saas-config';

@Component({
  selector: "app-cargo-item",
  templateUrl: "./cargo-item.component.html",
  styleUrls: ["./cargo-item.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
  // OnPush: cada fila del listado solo se re-evalúa cuando cambian sus @Input por
  // referencia o cuando ocurre un evento dentro de ella. Así la animación del menú
  // (que dispara CD global) deja de pagar el costo de chequear N filas acumuladas.
  // Requiere markForCheck() en las mutaciones de estado visible que ocurren de forma
  // asíncrona (fuera de un evento del template) — ver updateBalance() y callbacks.
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CargoItemService,
    VehiclesService,
    PermissionRole,
    DateFormatPipe,
    CargoManager,
  ],
})
export class CargoItemComponent implements OnInit {
  public vehicle: Vehicle;
  public lastPoint: string;
  public timeLastLocation: any;
  public lastInspection: any;
  @Input() cargo: Cargo;
  @Input() typeList: string;
  @Output() applyFilter: EventEmitter<any> = new EventEmitter();
  @Output() refreshCargo: EventEmitter<{ cargo: Cargo, action: 'update' | 'delete', reason?: string }> = new EventEmitter();
  @Output() navigate: EventEmitter<any> = new EventEmitter();
  @Input() option: FilterModel[];
  @Input() filters: string = '';
  // Estado de selección de la fila. Debe ser @Input (no leer cargo.checked directo en el
  // template) para que con OnPush la fila se repinte cuando "seleccionar todo" muta
  // cargo.checked: el padre re-evalúa [checked] y el cambio de input dispara el CD de la fila.
  @Input() checked: boolean;
  @Input() list: any;
  @Input() filteredCargosTurns: {
    cargoConsecutive?: number,
    matches?: TurnMatch[]
  };
  @Input() hideOptionsLoad: boolean = false;
  @Input() travelExpense?: TravelExpense;
  public expirationDateContainerEnum = ExpirationDateContainerEnum;
  public expirationBillEnum = ExpirationBillEnum;
  public ExpirationDateDTAEnum = ExpirationDateDTAEnum;
  public expirationDriverPaymentEnum = ExpirationDriverPaymentEnum;
  dialogFlags = {};
  diffInDaysContainerExp: number;
  diffInDaysBillExp: number;
  diffInDaysDriverPayment: number;
  badges: Array<{ message: string, style: string }> = [];
  user: User;
  permission = Permission;
  negotiation = {
    state: null,
    driver: null,
    negotiatedValueDriver: null,
    negotiatedValueCreator: null,
  };
  negotiationRequest = {
    state: null,
    companyId: null,
    negotiatedValueCompany: null,
    negotiatedValueCreator: null,
  };
  idUserActive = this.authService
    .getUserSession()
    .information.document;
  userActive = this.authService.getUserSession().information;
  // public listAdditionalService: AdditionalCost[] = [];
  listActive: string = "";
  expirationDaysDTAToLoad: number = 0;
  expirationDaysDTAToDownload: number = 0;
  listRoles: Role[] = [];
  listAbleRoles: Role[] = [];
  pendingReceivables: string = "";

  travelExpenseTypes: Array<CatalogItem> = [];
  listCompanies: BasicCompany[] = [];
  company: Company;
  travelExpenses: Array<TravelExpense>;
  /** Indica si los viáticos se cargaron realmente vía HTTP (relevante en modo lazy). */
  travelExpensesLoaded = false;

  public incident: any = { asset: null, name: null, id: null };
  public dateManager = DateManager;
  loadingCargo: boolean = false;
  listenerId: string;
  firstUpdate: boolean = false;
  cargoChangesSub: Subscription;
  private realtimePayments: CargoPaymentDetail[] = [];
  private paymentsSubscription: Subscription | null = null;
  public balance: number = 0;
  public hasMultipleTransportCompanies = false;
  private transportCompaniesSubscription: Subscription | null = null;
  constructor(
    public utils: Utils,
    public cargoItemService: CargoItemService,
    public rolesService: RolesService,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private authService: AuthService,
    public route: ActivatedRoute,
    private adminUsersService: AdminUsersService,
    public global: Global,
    public matDialog: MatDialog,
    private vehiclesService: VehiclesService,
    public permissionRole: PermissionRole,
    public titles: Titles,
    public dialog: Dialog,
    public cargoListService: FreightListService,
    public dialogMat: MatDialog,
    private cargoManager: CargoManager,
    public receivableService: ReceivableService,
    public cargoService: CargoService,
    private accountService: AccountService,
    private travelExpensesService: TravelExpensesService,
    public cargoPaymentsService: CargoPaymentsService,
    private companiesService: CompaniesService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.company = this.authService && this.authService.getCompany();
    this.listCompanies = this.accountService.listRegisterCompanies();
    if (sessionStorage.getItem("_lastList")) {
      this.listActive = sessionStorage.getItem("_lastList").toString();
    }
    this.initializeCargo(this.cargo);
    this.loadTransportCompaniesVisibility();

    const realtime = resolveCargoRealtime(this.typeList);
    if (realtime.paymentsWatch) this.subscribeToPayments(this.cargo.id);

    if (realtime.cargoWatch) {
      const { id, eventEmitter } = this.cargoService.watch(this.cargo.id);
      this.listenerId = id;
      this.cargoChangesSub = eventEmitter.subscribe(async (cargo: Cargo) => {
        if (!cargo || (cargo && this.cargo && cargo.id !== this.cargo.id)) return;
        if (!this.firstUpdate && this.isPaymentAcceptOrChargesList) {
          this.firstUpdate = true;
          return;
        }
        const newCargo = this.cargoService.updateSecureCargo(this.cargo, cargo);
        const { isAvailable, reason } = this.cargoListService.getCargoAvailableToList(cargo, this.typeList, this.filters);
        if (!this.utils.deepEqual(this.utils.clone(this.cargo), this.utils.clone(newCargo))) {
          if (!isAvailable) console.warn(`El servicio ${this.cargo.consecutive} no es apto para el listado por ${reason}`);
          this.refreshCargo.emit({ cargo: newCargo, action: isAvailable ? 'update' : 'delete', reason });
        }

      }, () => console.error(`No es posible escuchar los cambios del servicio ${this.cargo.consecutive}`));
    }
  }

  private initializeCargo(cargo: Cargo) {
    this.cargo = cargo;
    this.incident = this.cargoItemService.getIndicator(this.cargo);
    //Badges
    if (this.cargo.containerExpirationDate) this.getContainerExpirationDate();
    if (this.cargo.approvalDate && this.canAlertBill) this.getBillExpirationDate();
    if (this.cargo.dateLoad && this.canAlertDriverPayment) this.getDriverPaymentDate();
    if (this.cargo.cargoModel && this.cargo.cargoModel.tripType &&
      this.cargo.cargoModel.tripType.date && ['DUTA', 'OTM', 'DTA'].
        includes(this.cargo.cargoModel.tripType.regimeType))
      this.getDTAExpirationDate()
    this.badges = this.alertsBadges;
    if (!this.utils.isDefined(this.travelExpenses) && this.canAccessTravelExpenses) {
      if (this.utils.isDefined(this.cargo.travelExpenses) && Array.isArray(this.cargo.travelExpenses)) {
        this.travelExpenses = this.cargo.travelExpenses;
        this.updateBalance();
      } else if (CARGO_TRAVEL_EXPENSES_LAZY) {
        // Modo lazy: no consultar viáticos por item. Se cargan bajo demanda al
        // abrir el detalle de saldo. El saldo de la fila no descuenta viáticos.
        this.travelExpenses = [];
        this.updateBalance();
      } else this.getTravelExpenses().then(() => this.updateBalance());
    } else this.updateBalance();
    if (this.cargoLastPointLocation.date)
      this.lastPoint = DateManager.dateDiffFromNow(this.cargoLastPointLocation.date, 'YYYY-MM-DD HH:mm ZZ', false);
  }

  private loadTransportCompaniesVisibility(): void {
    if (!this.cargo || !this.cargo.transportCompany || !this.cargo.transportCompany.name) return;

    this.transportCompaniesSubscription = this.companiesService.getCachedSaasTransportCompanies().subscribe(
      companies => {
        this.hasMultipleTransportCompanies = (companies || []).length > 1;
        this.cdRef.markForCheck();
      },
      () => {
        this.hasMultipleTransportCompanies = false;
        this.cdRef.markForCheck();
      }
    );
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cargo && changes.cargo.currentValue && this.utils.isDefined(changes.cargo.currentValue)) {
      const cargo = changes.cargo.currentValue;
      const prevId = changes.cargo.previousValue && changes.cargo.previousValue.id;
      if (cargo.id !== prevId && resolveCargoRealtime(this.typeList).paymentsWatch) this.subscribeToPayments(cargo.id);
      if (this.isNegotiation) this.validateDataNegotiation(cargo);
      else this.initializeCargo(cargo);
    }
  }

  get isNegotiation(): boolean {
    let state = false;
    switch (this.typeList) {
      case "loadsInNegotiation":
      case "cargoRequestNegotiation":
        state = true;
        break;
    }
    return state;
  }
  public goToList() {
    this.router.navigate(["cargo/list/" + this.listActive]);
  }

  showAdditionalServiceCargo() {
    if (this.dialogFlags['UpdateAdditionalCostCargoComponent']) return;
    this.dialogFlags['UpdateAdditionalCostCargoComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      listAdditionalService: this.cargo.additionalCosts,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialogMat.open(
      UpdateAdditionalCostCargoComponent,
      dialogConfig
    ).afterClosed().subscribe(() => {
      this.dialogFlags['UpdateAdditionalCostCargoComponent'] = false;
      this.goToList();
      this.applyFilter.emit();
    });
  }

  validateDataNegotiation(cargo: Cargo) {
    if (this.utils.isDefined(cargo)) this.initializeCargo(cargo);
    if (this.utils.isDefined(cargo.state)) this.negotiation.state = cargo.state;
    if (this.utils.isDefined(cargo.driver)) this.negotiation.driver = cargo.driver;
    if (this.utils.isDefined(cargo['negotiatedValueDriver'])) this.negotiation.negotiatedValueDriver = cargo['negotiatedValueDriver'];
    if (this.utils.isDefined(cargo['negotiatedValueCreator'])) this.negotiation.negotiatedValueCreator = cargo['negotiatedValueCreator'];
    if (this.utils.isDefined(cargo['companyId'])) this.negotiationRequest.companyId = cargo['companyId'];
    if (this.utils.isDefined(cargo['negotiatedValueCompany'])) this.negotiationRequest.negotiatedValueCompany = cargo['negotiatedValueCompany'];
  }

  openDetail(cargo: Cargo) {
    let route = "/cargo/detail";
    sessionStorage.setItem("_lastList", this.typeList.toString());

    if (this.isLoadingRoutesTab || cargo.state === CargoStateEnum.START_SERVICE)
      route = "/cargo/tracking/";
    else if (cargo.state === CargoStateEnum.REQUEST)
      route = "/service-request-form/menu-service";

    if (this.typeList === "loadsInNegotiation") {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiation = this.negotiation;
      this.navigate.emit("cargo/negotiation");
      this.router.navigate(["cargo/negotiation"]);
    } else if (this.typeList === "cargoRequestNegotiation") {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiationRequest = this.negotiationRequest;
      this.navigate.emit("cargo/negotiation");
      this.router.navigate(["cargo/negotiation"]);
    } else {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiation = {
        state: null,
        driver: null,
        negotiatedValueDriver: null,
        negotiatedValueCreator: null,
      };
      this.navigate.emit("cargo/negotiation");
      this.router.navigate([route, cargo.consecutive]);
    }
  }

  isFixedCargo() {
    if (
      this.utils.isDefined(this.cargo) &&
      this.utils.isDefined(this.cargo.cargoFeature) &&
      this.utils.isDefined(this.cargo.cargoFeature.productType) &&
      this.utils.isDefined(this.cargo.cargoFeature.productType.type) &&
      this.cargo.cargoFeature.productType.type !== "FixedCargo"
    ) {
      return true;
    } else {
      return false;
    }
  }

  openDetailVehicle() {
    if (this.dialogFlags['DetailVehicleComponent']) return;
    this.dialogFlags['DetailVehicleComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: this.vehicle,
      close: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    this.matDialog.open(DetailVehicleComponent, dialogConfig).afterClosed().subscribe(() => this.dialogFlags['DetailVehicleComponent'] = false);
  }

  openDetailDriver() {
    if (this.dialogFlags['UserFormComponent']) return;
    this.dialogFlags['UserFormComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      driver: this.user,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialogMat.open(
      UserFormComponent,
      dialogConfig
    ).afterClosed().subscribe(() => {
      this.dialogFlags['UserFormComponent'] = false;
    })
  }

  getDetailUserByDocument() {
    if (!this.showDriverDetail) return;
    this.spinner.show();
    this.adminUsersService
      .getUsersDetailByDocument(this.cargo.driver)
      .subscribe(
        (success: User) => {
          this.user = success;
          this.spinner.hide();
          this.openDetailDriver();
        },
        (error) => {
          this.user = null;
          this.spinner.hide();
          this.openDetailDriver();
        }
      );
  }

  async getDetailVehicle(openDetail?: boolean): Promise<boolean> {
    if (!this.cargo || !this.utils.isDefined(this.cargo.licensePlate)) {
      if (openDetail) this.snackBarService.openSnackBar('No se encontró el vehículo', undefined, 'error');
      return false;
    }
    let vehicle: Vehicle;
    this.spinner.show();
    try { vehicle = await this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).toPromise(); } catch (error) { }
    const vehicleFound = vehicle && vehicle.id === this.cargo.licensePlate;
    if (vehicleFound)
      this.vehicle = vehicle;
    this.cdRef.markForCheck();
    this.spinner.hide();
    if (openDetail) vehicleFound ? this.openDetailVehicle() : this.snackBarService.openSnackBar('No se encontró el vehículo', undefined, 'error');
    return vehicleFound;
  }

  async showBankAccountHolder(account: 'advance' | 'balance') {
    this.spinner.show();
    let vehicle: Vehicle;
    try {
      const serviceVehicle = await this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).toPromise();
      if (serviceVehicle) vehicle = serviceVehicle;
    } catch (error) { }
    if (!vehicle) {
      this.spinner.hide();
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
    const bankAccount = account === 'advance' ? vehicle['bankAccountAdvance'] : vehicle['bankAccountBalance'];
    if (!bankAccount) {
      this.spinner.hide();
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Cuenta bancaría de ${account === 'advance' ? 'anticipos' : 'saldos'}`,
      icon: true,
      descriptionHTML: `<p>La información de la cuenta bancaría de ${account === 'advance' ? 'anticipos' : 'saldos'} es la siguiente:</p>
      <ul>
        <li>Titular: <b>${bankAccount.name ? bankAccount.name : '-'}</b></li>
        <li>Documento: <b>${bankAccount.document ? bankAccount.document : '-'}</b></li>
        <li>Tipo de cuenta: <b>${bankAccount.accountType ? bankAccount.accountType : '-'}</b></li>
        <li>Número de cuenta: <b>${bankAccount.accountNumber ? bankAccount.accountNumber : '-'}</b></li>
      </ul>`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    this.spinner.hide();
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  getContainerExpirationDate() {
    this.diffInDaysContainerExp = DateManager.dateDiff(this.cargo.containerExpirationDate, 'DD/MM/YYYY', new Date());
  }
  get containerType(): string {
    const cargoType = this.utils.getNestedValue(this.cargo, 'cargoModel.cargoType.name');
    if (cargoType !== 'Contenedor') return '';
    const containerType = this.utils.getNestedValue(this.cargo, 'cargoModel.serviceType.name');
    return containerType ? containerType : 'Contenedor';
  }
  getBillExpirationDate() {
    this.diffInDaysBillExp = DateManager.dateDiff(DateManager.add(this.cargo.approvalDate, 5, 'days'), null, new Date());
  }

  get canAlertBill(): boolean {
    return this.typeList === 'charges' && !!this.cargo && !!this.cargo.approvalDate &&
      !DateManager.isBefore(
        DateManager.stringToDate(this.cargo.approvalDate),
        DateManager.stringToDate('23/02/2024', 'DD/MM/YYYY'));
  }

  get canAlertDriverPayment(): boolean {
    const hasPermissionToPaymentCargo = this.permissionRole.hasPermission(this.permission.payments.module, this.permission.payments.paymentCargo);
    if (!hasPermissionToPaymentCargo) return false;
    const daysToPayment = Number(this.utils.getNestedValue(this.cargo, 'shippingCost.paymentTime'));
    const isPaid = this.utils.getNestedValue(this.cargo, 'shippingCost.paid');
    return !!this.cargo && !isPaid && daysToPayment > 0 && DateManager.dateDiff(this.cargo.dateLoad, null, new Date()) <= daysToPayment;
  }
  getDriverPaymentDate() {
    const dateLoad = this.utils.getNestedValue(this.cargo, 'dateLoad');
    const dateLoadDate = dateLoad ? DateManager.stringToDate(dateLoad) : null;
    const daysToPayment = Number(this.utils.getNestedValue(this.cargo, 'shippingCost.paymentTime'));
    const dateLoadPlusDaysToPayment = dateLoadDate ? DateManager.add(dateLoadDate, daysToPayment, 'days') : null;
    this.diffInDaysDriverPayment = DateManager.dateDiff(dateLoadPlusDaysToPayment, null, new Date());
  }

  getDTAExpirationDate() {
    this.expirationDaysDTAToLoad = DateManager.dateDiff(DateManager.add(this.cargo.cargoModel.tripType.date, 5, 'days', 'YYYY-MM-DD'));
    this.expirationDaysDTAToDownload = DateManager.dateDiff(DateManager.add(this.cargo.cargoModel.tripType.date, 10, 'days', 'YYYY-MM-DD'));
  }

  async confirmDriverValidations() {
    try {
      this.spinner.show();
      let successInspection: VehicleInspect;
      const successVehicle = await this.getDetailVehicle();
      if (successVehicle && this.cargo && this.cargo.vehicleInspection) {
        successInspection = await this.cargoItemService.getInspection(this.cargo.vehicleInspection, "vehicle").toPromise() as VehicleInspect;
        if (successInspection) {
          this.spinner.hide();
          this.lastInspection = successInspection;
          this.openModalConfirmDriver();
          this.belowSicetac(this.cargo, this.cargo.state === CargoStateEnum.REQUEST
            ? `service-request-form/menu-service/${this.cargo.consecutive}`
            : `cargo/detail/${this.cargo.consecutive}`);
          return;
        }
      }
      this.spinner.hide();
      this.snackBarService.openSnackBar(
        !successVehicle ? 'No se encontró el vehículo' : !successInspection ? 'No se encontró la inspección preoperacional del vehículo' : ServiceMessages.GENERAL_HTTP_ERROR,
        undefined,
        'error'
      );
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  openModalConfirmDriver() {
    //No hay inspección vehícular
    const assignment = this.isEscortedService ? 'escolta' : this.isSatelliteLockService ? 'candado satelital' : 'vehículo';
    if (!this.lastInspection || !this.lastInspection.id) {
      const whoDocument = this.cargo.assignedVehicleFingerPrint
        ? this.cargo.assignedVehicleFingerPrint.userId
        : this.cargo.numberDocumentCreatorLoad;
      if (this.authService && whoDocument === this.authService.getUserSession().information.document)
        return this.createInspection();

      const who = this.cargo.assignedVehicleFingerPrint
        ? this.cargo.assignedVehicleFingerPrint.userName
        : `el Operador que asignó el ${assignment}`;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: `No se encontró registrada una inspección preoperacional del ${assignment}. 
        Debes comunicarte con ${who} para solicitar el registro de la inspección.`,
        hideBtnCancel: true,
      };
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.SMALL_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      this.dialogMat.open(DialogComponent, dialogConfig);
      return;
    }
    //Tiene inspección vehícular pero no está aprobada
    if (!this.utils.isDefined(this.lastInspection.approval))
      return this.snackBarService.openSnackBar(`Aún no se ha aprobado la Inspección preoperacional del ${assignment}`, undefined, "alert");
    if (!this.lastInspection.approval)
      return this.snackBarService.openSnackBar(`La Inspección preoperacional del ${assignment} está rechazada`, undefined, "error");
    this.validateReceivables();
  }

  private createInspection() {
    this.cargoManager.checkInspection(this.cargo, this.authService.getUserSession().information, this.cargo.licensePlate)
      .then((vehicleInspectionId) => {
        if (!vehicleInspectionId) this.confirmDriverValidations();
        else this.applyFilter.emit();
      }).catch(() => { });
  }

  get isPrincipalCompany(): boolean {
    return !!(this.listCompanies.length && this.company && this.company.companyId && this.listCompanies.some(company => company.nit === this.company.companyId));
  }

  dialogConfirmDriver() {
    if (this.dialogFlags['DialogComponent']) return;
    this.dialogFlags['DialogComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: this.titles.titleConfirmDriver,
      subtitle: this.pendingReceivables ? this.pendingReceivables : '',
      licen: this.pendingReceivables ? '' : this.cargo.licensePlate,
      idCargo: this.pendingReceivables ? '' : this.cargo.consecutive,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = this.pendingReceivables ? ModalEnum.LARGE_WIDTH : ModalEnum.MEDIUM_WIDTH;

    this.matDialog.open(DialogComponent, dialogConfig).afterClosed().subscribe((result) => {
      this.dialogFlags['DialogComponent'] = false;
      if (result && result.state) {
        const data: any = {
          cargoId: this.cargo.id,
          fingerprint: {
            userId: this.authService
              .getUserSession()
              .information.document,
            userName: this.authService
              .getUserSession()
              .information.name,
          },
        };
        const approval = result.refuse;
        this.confirmDriver(data, approval);
      }
    });
  }

  confirmDriver(data, approval) {
    this.spinner.show();
    this.cargoItemService.confirmDrive(data, approval).subscribe(
      (success: Cargo) => {
        this.spinner.hide();
        this.applyFilter.emit();
        if (
          !this.utils.isEmpty(success) &&
          !this.utils.isEmpty(success.message)
        ) {
          this.dialog.openDialog({
            title: success.message,
            iconError: true,
            hideBtnConfirm: true,
          }).then().catch(err => err);
        } else {
          this.snackBarService.openSnackBar(approval && approval === 'true' ? "Placa confirmada correctamente" : "Se ha rechazado la confirmacion correctamente");
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        if (
          !this.utils.isEmpty(error) &&
          !this.utils.isEmpty(error.error) &&
          !this.utils.isEmpty(error.error.message)
        ) {
          this.snackBarService.openSnackBar(
            error.error.message,
            undefined,
            "alert"
          );
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al confirmar la placa",
            undefined,
            "error"
          );
        }
      }
    );
  }

  validateReceivables() {
    const observerListReceivables = {
      next: (data) => {
        if (data && data.some(receivable => receivable.state && receivable.state.description && receivable.state.description === 'pending')) {
          this.pendingReceivables = `El tenedor de este vehiculo ( ${this.vehicle.bankAccountBalance.name} ) tiene carteras pendientes. ¿Está seguro que desea confirmar la placa ${this.cargo.licensePlate} como vehiculo para el servicio ${this.cargo.consecutive}?`;
        } else {
          this.pendingReceivables = "";
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      },
      complete: () => {
        this.dialogConfirmDriver();
        this.spinner.hide();
      }
    };
    if (this.vehicle && this.vehicle.bankAccountBalance && this.vehicle.bankAccountBalance.document) {
      this.spinner.show();
      this.receivableService.getReceivableList(null, null, this.vehicle.bankAccountBalance.document).subscribe(observerListReceivables);
    } else {
      this.pendingReceivables = "";
      this.dialogConfirmDriver();
    }
  }

  public semaphoreApproved() {
    if (
      this.cargo.state == CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.paid &&
      this.cargo.durationTime
    ) {
      let endDateWithExtraHours: Date = DateManager.add(this.cargo.durationTime.endDate, 72, 'hours');
      let diff;
      if (DateManager.isSameOrBefore(endDateWithExtraHours, new Date())) {
        diff = DateManager.dateDiff(new Date(), null, endDateWithExtraHours);
      } else {
        diff = DateManager.dateDiff(endDateWithExtraHours, null, new Date());
      }

      if (this.cargo.stateTracking != 'Pause') {
        if (diff > 0 && diff <= 15) {
          return { "border-left": "10px solid blue" };
        } else if (diff > 15 && diff <= 30) {
          return { "border-left": "10px solid orange" };
        } else if (diff > 30) {
          return { "border-left": "10px solid red" };
        }
      }

      return { "border-left": "10px solid white" };
    } else if (
      this.cargo.state == CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      this.cargo.shippingCost.paid
    ) {
      return { "border-left": "10px solid green" };
    }
  }

  get semaphore() {
    if (this.option && this.option.some(option => [Filter.showFilterAprovedCargo, Filter.showFilterMinistryFulfillment].includes(option.filterName))) {
      return this.semaphoreApproved();
    } else if (this.showTransportedValueSemaphore()) {
      const valueSemaphore = this.semaphoreCargooAmount();
      // Sin alerta el semáforo devuelve un borde blanco inline que tapaba el
      // borde de la card; en ese caso no inyectamos borde y dejamos el del CSS.
      return valueSemaphore && valueSemaphore.border === 'solid white' ? undefined : valueSemaphore;
    } else if (this.showSemaphorepayment()) {
      return this.semaphoreState();
    }
  }

  get hasTransportedValueAlert(): boolean {
    return this.showTransportedValueSemaphore() && this.semaphoreCargooAmount().border !== 'solid white';
  }

  get semaphoreBody() {
    const semaphore = this.semaphoreCargooAmount();
    let background = semaphore["border"].split(" ")[2] || semaphore["border"].split(" ")[1];

    const contrast_white = ColorService.getContrast(parseInt(`0xff${background.slice(1)}`), 0xffffffff);
    const contrast_black = ColorService.getContrast(parseInt(`0xff${background.slice(1)}`), 0xff000000);
    let color = contrast_white > contrast_black ? '#ffffff' : '#000000';

    if (this.cargo.stateTracking == 'Pause') {
      color = '#000000';
      background = '#ffffff';
    }

    return { background, color };
  }

  get riskProfile() {
    return this.cargo.riskProfile && this.cargo.riskProfile.name ? this.cargo.riskProfile.name : '';
  }

  public semaphoreCargooAmount() {
    let absDiff = 0
    if (this.cargoLastPointLocation.date) {
      const diff = DateManager.dateDiff(this.cargoLastPointLocation.date, null, new Date(), 'YYYY-MM-DD HH:mm ZZ', 'minutes');
      absDiff = Math.abs(diff);
    }

    if (absDiff) {
      if (absDiff > AmountsCargoEnum.EMPTY_ALERT_MINS) {
        return { border: "solid #495356" };
      }
      if (absDiff > AmountsCargoEnum.LOW_ALERT_MINS && absDiff <= AmountsCargoEnum.EMPTY_ALERT_MINS) {
        return { border: "solid #FF3203" };
      }
      if (absDiff > AmountsCargoEnum.MEDIUM_ALERT_MINS && absDiff <= AmountsCargoEnum.LOW_ALERT_MINS) {
        return { border: "solid #FFDC1C" };
      }
      if (absDiff > AmountsCargoEnum.HIGH_ALERT_MINS && absDiff <= AmountsCargoEnum.MEDIUM_ALERT_MINS) {
        return { border: "solid #44C98B" };
      }
      if (absDiff <= AmountsCargoEnum.HIGH_ALERT_MINS) {
        return { border: "solid #00D0F5" };
      }
    }

    return { border: "solid white" };

  }

  public isPendingConfirmLicensePlate(): boolean {
    const minRequirements = !this.isNegotiation && this.cargo && this.cargo.driver && !this.cargo.confirmedDriver && [CargoStateEnum.ACCEPTED].includes(this.cargo.state);
    if (!minRequirements) return false;
    const isSpecialLicensePlate = this.cargo.licensePlate === "C0N111";
    const isLowRiskLicensePlate = this.utils.getNestedValue(this.cargo, 'riskProfile.name') === "Riesgo bajo";
    const hasPermissionSpecialLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.specialLicensePlate);
    const hasPermissionConfirmLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.confirmLicensePlate);
    const hasPermissionConfirmLicensePlateOfLowRiskCargo = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.confirmLicensePlateOfLowRiskCargo);
    if (isSpecialLicensePlate)
      return hasPermissionSpecialLicensePlate;
    if (isLowRiskLicensePlate && hasPermissionConfirmLicensePlateOfLowRiskCargo)
      return true;
    return hasPermissionConfirmLicensePlate;
  }

  get hasPermissionFinancier(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module,
      this.permission.cargo.cargoItemFinancier);
  }

  get hasPermissionShowRateCargo(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module,
      this.permission.cargo.showRateCargo);
  }

  public validateTime(diff) {
    const amount = this.utils.getNestedValue(this.cargo, 'cargoFeature.cargoMeasure.amount');
    const realAmount = this.utils.isDefined(amount) ? Number(amount) : 0;
    if (realAmount <= 400000000) {
      if (diff > 180) return { color: "#FFB71C" };
      if (diff >= 120) return { color: "#F5D527" };
    } else if (realAmount <= 700000000) {
      if (diff > 120) return { color: "#584796" };
      if (diff >= 60) return { color: "#7961CF" };
    } else {
      if (diff > 120) return { color: "#161616" };
      if (diff >= 60) return { color: "#333333" };
    }
    return { display: "none" };
  }

  public semaphoreState() {
    if (
      this.cargo.state == CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.paid &&
      this.cargo.durationTime
    ) {
      const diff = DateManager.dateDiff(new Date(), null, this.cargo.durationTime.endDate);
      if (diff > 0 && diff <= 15) {
        return { "border-left": "10px solid blue" };
      } else if (diff > 15 && diff <= 30) {
        return { "border-left": "10px solid orange" };
      } else if (diff > 30) {
        return { "border-left": "10px solid red" };
      } else {
        return { "border-left": "10px solid white" };
      }
    } else if (
      this.cargo.state == CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      this.cargo.shippingCost.paid
    ) {
      return { "border-left": "10px solid green" };
    }
  }

  get showSiigoIcon(): boolean {
    return this.cargo &&
      this.cargo.shippingCost &&
      this.cargo.shippingCost.taxSiigo > 0 &&
      this.utils.isDefined(this.cargo.shippingCost.taxSiigo)
  }

  public showTransportedValueSemaphore(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.transportedValueSemaphore
    );
  }

  public showSemaphorepayment() {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.paymentSemaphore
    );
  }
  public getValueAdditionalCost(type: string): number {
    let value: number = 0;
    if (this.cargo && this.cargo.additionalCosts) {
      const additionalLoadList = this.cargo.additionalCosts.filter(
        (additionalCost) => {
          return additionalCost.type.name === type;
        }
      );
      for (const additionalCost of additionalLoadList) {
        value += (additionalCost && additionalCost.financialInformation) ? additionalCost.financialInformation.cost : 0;
      }
    }
    return value;
  }

  public getValueAdditionalRate(type: string): number {
    let value: number;
    if (this.cargo && this.cargo.additionalCosts) {
      const additionalLoadList = this.cargo.additionalCosts.filter(
        (additionalCost) => {
          return additionalCost.type.name === type;
        }
      );
      if (
        additionalLoadList.length &&
        additionalLoadList[0].financialInformation
      ) {
        value = additionalLoadList[0].financialInformation.rate;
      }
    }
    return value;
  }

  public openDialogDetailAdditionalService() {
    if (this.dialogFlags['SummaryAdditionalCostCargoComponent']) return;
    this.dialogFlags['SummaryAdditionalCostCargoComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      additionalCosts: this.cargo.additionalCosts,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialogMat.open(SummaryAdditionalCostCargoComponent, dialogConfig).afterClosed().subscribe(() => {
      this.dialogFlags['SummaryAdditionalCostCargoComponent'] = false;
    });
  }

  async getShowAdditionalService() {
    return this.cargo.additionalCosts && this.cargo.additionalCosts.length > 0;
  }

  public validateApproveBalance(): void {
    if (this.isPendingApproveBalance()) {
      if (!this.listRoles.length) {
        this.rolesService.getRolesByNit(this.authService.getUserSession().clientCompanyId).subscribe(
          (roles: Role[]) => {
            this.listRoles = roles;
            this.listAbleRoles = this.listRoles.filter(
              role => role && role.modules && role.modules.some(
                module => module.name === "cargo" && module.functionalities && module.functionalities.some(
                  funct => funct.name === "approveBalanceDriver" && funct.visible
                )
              )
            )
            this.dialog.openDialog(
              {
                title: "¡Aprobación Pendiente!",
                description:
                  this.listAbleRoles.length ?
                    `El conductor debe aprobar el pago del saldo desde la aplicación móvil, de lo contrario contactar a un usuario con rol ${this.listAbleRoles.map(role => role.name).join(', ')} para aprobar el pago` :
                    "El conductor debe aprobar el pago del saldo desde la aplicación móvil",
                iconError: true,
                hideBtnConfirm: true,
              }
            ).then().catch(err => err);
          },
          (error) => {
            this.listRoles = [];
          }
        );
      } else {
        this.dialog.openDialog(
          {
            title: "¡Aprobación Pendiente!",
            description:
              this.listAbleRoles.length ?
                `El conductor debe aprobar el pago del saldo desde la aplicación móvil, de lo contrario contactar a un usuario con rol ${this.listAbleRoles.map(role => role.name).join(', ')} para aprobar el pago` :
                "El conductor debe aprobar el pago del saldo desde la aplicación móvil",
            iconError: true,
            hideBtnConfirm: true,
          }
        ).then().catch(err => err);
      }
    }
  }


  public get warningAlertsCargo(): { [key: string]: boolean } {
    const alerts = {};
    if (this.isPendingApproveBalance()) alerts['isPendingApproveBalance'] = true;
    if (this.isPendingConfirmLicensePlate()) alerts['isPendingConfirmLicensePlate'] = true;
    if (this.isPendingApproveBankAccount()) alerts['isPendingApproveBankAccount'] = true;
    if (this.isPendingApprove()) alerts['isPendingApprove'] = true;
    if (this.isPendingApproveTravelExpense()) alerts['isPendingApproveTravelExpense'] = true;
    return alerts;
  }
  public get showWarningAlertsCargo(): boolean {
    return Object.values(this.warningAlertsCargo).length && Object.values(this.warningAlertsCargo).some(alert => alert);
  }

  public get infoAlertsCargo(): { [key: string]: boolean } {
    const alerts = {};
    if (this.typeList == 'approvePayments' && this.cargo && [CargoStateEnum.END_SERVICE].includes(this.cargo.state))
      alerts['stateApproval'] = true;
    if (this.typeList == 'rndcFulfillments' && this.cargo && [CargoStateEnum.END_SERVICE].includes(this.cargo.state))
      alerts['stateRndcFulfillment'] = true;
    if (!this.utils.getNestedValue(this.cargo, 'shippingCost.paid') && this.utils.getNestedValue(this.cargo, 'validatedBankAccount')
      && this.showVehicleDetail && this.cargo.licensePlate) {
      if (this.typeList == 'paymentAdvanceCargo') alerts['showAdvanceAccount'] = true;
      if (this.typeList == 'paymentBalanceCargo') alerts['showBalanceAccount'] = true;
    }
    return alerts;
  }
  public get showInfoAlertsCargo(): boolean {
    return Object.values(this.infoAlertsCargo).length && Object.values(this.infoAlertsCargo).some(alert => alert);
  }

  public isPendingApproveTravelExpense(): boolean {
    return this.cargo.unlegalizedTravelExpense && this.cargo.state === CargoStateEnum.END_SERVICE && this.canAccessTravelExpenses;
  }

  public isPendingApproveBalance(): boolean {
    return (
      this.cargoItemService.isApproveBalance(this.cargo) === false &&
      this.cargo.state === CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.paid && (this.isTransportService || this.isEscortedService)
    );
  }

  public isPendingApprove(): boolean {
    return (
      this.cargo.approval !== "Approved" &&
      this.cargo.state === CargoStateEnum.END_SERVICE &&
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.paid &&
      this.isPendingApproveTravelExpense()
    );
  }

  public get cargoWithVehicleConfirmed(): boolean {
    return this.cargo.confirmedDriver;
  }

  public isPendingApproveBankAccount() {
    return (
      this.cargoWithVehicleConfirmed && (this.isTransportService || this.isEscortedService) &&
      this.cargoListService.isPaymentCargo(this.typeList) &&
      ((this.utils.isDefined(this.cargo.validatedBankAccount) &&
        !this.cargo.validatedBankAccount) ||
        (!this.utils.isDefined(this.cargo.validatedBankAccount) &&
          this.cargo.shippingCost &&
          !this.cargo.shippingCost.paid))
    );
  }

  AvaliableTurnList() {
    if (!this.filteredCargosTurns || (this.filteredCargosTurns && this.filteredCargosTurns.matches.length === 0)) return;
    if (this.dialogFlags['AssignVehicleCargoComponent']) return;
    this.dialogFlags['AssignVehicleCargoComponent'] = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Datos del Vehículo Asignado",
      filteredCargosTurns: this.filteredCargosTurns,
      cargo: this.cargo,
      type: 'turn'
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(AssignVehicleCargoComponent, dialogConfig).afterClosed().subscribe(result => {
      this.dialogFlags['AssignVehicleCargoComponent'] = false;
      if (result && result.state) this.applyFilter.emit();
    });
  }

  public async summaryBalance(_cargo: Cargo) {
    if (this.dialogFlags['SummaryBalanceComponent']) return;
    this.dialogFlags['SummaryBalanceComponent'] = true;
    if (CARGO_TRAVEL_EXPENSES_LAZY && !this.travelExpensesLoaded && this.canAccessTravelExpenses) {
      this.spinner.show();
      await this.getTravelExpenses();
      this.spinner.hide();
      await this.updateBalance();
    }
    const merged = this.mergedCargo;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      data: await this.cargoItemService.getSummaryBalance(merged, this.travelExpenses)
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(SummaryBalanceComponent, dialogConfig).afterClosed().subscribe(() => {
      this.dialogFlags['SummaryBalanceComponent'] = false;
    });
  }

  public get activeBell(): boolean {
    return (
      this.cargo &&
      this.cargo.state === this.cargoStateEnum.START_SERVICE &&
      this.showTransportedValueSemaphore()
    );
  }

  public get isLoadingRoutesTab(): boolean {
    const list = ['loadingRoutes', 'emptyContainers', 'urbanRoutes', 'lastMileRoutes', 'nationalRoutes', 'exportRoutes', 'importRoutes', 'internationalRoutes'];
    return list.includes(this.typeList);
  }

  public get isPaymentAcceptOrChargesList(): boolean {
    const list = ['charges', 'approvePayments', 'rndcFulfillments', 'paymentAdvanceCargo', 'paymentExtraAdvanceCargo', 'paymentBalanceCargo', 'paymentAdditionalCostsCargo', 'paymentTravelExpenses'];
    return list.includes(this.typeList);
  }

  public get showItemOptions(): boolean {
    return !!(this.canEditCargo || (this.cargo && !this.cargo.assignedDriver && !this.cargo.licensePlate && this.showAssignVehicleBtn))
  }

  public get escortedVehicleTooltip(): string {
    if (!this.cargo || !this.cargo.escortedVehicle || !this.cargo.escortedVehicle.licensePlate) return '';
    const escortedVehicle = this.cargo.escortedVehicle;
    return `${escortedVehicle.licensePlate} - Conductor: ${escortedVehicle.driver.name} - Celular: ${escortedVehicle.driver.phoneNumber}`;
  }



  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }
  get isSatelliteLockService(): boolean {
    return this.utils.isSatelliteLockService(this.cargo);
  }
  get isTransportService(): boolean {
    return this.utils.isTransportService(this.cargo);
  }

  public get trackingTime(): string {
    if (this.cargoLastPointLocation.date) {
      const lastTrack = DateManager.dateDiffFromNow(this.cargoLastPointLocation.date, null, false);
      return lastTrack ? lastTrack : "Desconocido";
    }
    return "Sin seguimientos";
  }

  /**
   * Si el servicio aún no tiene seguimientos, informa cuánto tiempo ha pasado
  * desde que entró en ruta. No reemplaza el tiempo del último seguimiento.
  */
  public get startRouteTime(): string {
    if (this.cargoLastPointLocation.date || !this.cargo || !this.cargo.lastPointLocationDateOrder) return '';

    const elapsedTime = DateManager.dateDiffFromNow(this.cargo.lastPointLocationDateOrder, null, false);
    return elapsedTime
      ? elapsedTime.charAt(0).toUpperCase() + elapsedTime.slice(1)
      : '';
  }

  get cargoLastPointLocation(): { date: Date, address: string, city: string } {
    return this.utils.getCargoLastPointLocation(this.cargo);
  }

  public get trackingRiskProfile(): string {
    let risk = 'No especificado';
    switch (this.riskProfile) {
      case "Riesgo alto": risk = 'Alto'; break;
      case "Riesgo medio": risk = 'Medio'; break;
      case "Riesgo bajo": risk = 'Bajo'; break;
    }
    return risk;
  }

  public get trackingRiskProfileBg(): { background: string } {
    let bgRisk = '#333333';
    switch (this.riskProfile) {
      case "Riesgo alto": bgRisk = '#F50D01'; break;
      case "Riesgo medio": bgRisk = '#F3B62A'; break;
      case "Riesgo bajo": bgRisk = '#00D0F5'; break;
    }
    return { background: bgRisk };
  }

  public openShippingCostDetails(type) {
    if (this.dialogFlags['CargoShippingCostDialogComponent']) return;
    this.dialogFlags['CargoShippingCostDialogComponent'] = true;
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      shippingCostToDisplay: this.cargo.shippingCost.modifications.filter((item) => item.type === type && !!item.amount),
      typePayment: 'DiscountsAndBonuses',
      cargo: this.cargo,
      finalRate: this.utils.getNestedValue(this.cargo, 'shippingCost.rate'),
      finalCost: this.cargoItemService.getRealCost(this.cargo, false),
      balance: this.balance
    };
    this.matDialog.open(CargoShippingCostDialogComponent, config).afterClosed().subscribe((response) => {
      this.dialogFlags['CargoShippingCostDialogComponent'] = false;
      if (response && response.state) this.applyFilter.emit();
    });
  }

  public belowSicetac(cargo: Cargo, path?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
    const min = formatter.format(cargo.minimumApprovedValueSicetac);
    if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approvedBelowSicetac)) {
      if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
        dialogConfig.data = {
          title: '¿Desea aprobar el flete por debajo del SICETAC?',
          descriptionHTML: `El flete mínimo permitido por SICETAC es de <strong>${min}</strong>, si desea ajustarlo por favor realice una bonificación para ajustarse al valor mínimo permitido.`,
          btnDetailCargo: true,
          path: path,
          closeModal: true,
        };
        dialogConfig.disableClose = true;
        const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          if (result && result.state) {
            this.cargoService.approvedBelowSiceTac(cargo.id).subscribe(
              () => {
                this.openConfirmBelowSicetac();
              },
              (error) => {
                this.snackBarService.openSnackBar("No se pudo aprobar", undefined, 'error');
              }
            );
          }
        })
      }
    } else {
      if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
        dialogConfig.data = {
          title: `El flete mínimo es ${min}, por favor realice una bonificación para ajustarse al valor mínimo permitido`,
          showBtn: true,
        };
        const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => { })
      }
    }
  }

  openConfirmBelowSicetac() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Aprobación exitosa`,
      icon: true,
      description: `Se ha aprobado el servicio por un flete que está por debajo del valor mínimo permitido por el SICETAC`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  get showVehicleDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readVehicleDetails);
  }

  get showDriverDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readDriverDetails);
  }

  get showAppUsageDiscount(): boolean {
    return (this.authService && !!this.authService.getCompany() && !!this.authService.getCompany().appUsageDiscountEnabled) || this.utils.isTeclogiUserOrClient;
  }

  get showTurnVehicles(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.viewTurnVehicles);
  }

  get cargoStateEnum(): typeof CargoStateEnum {
    return CargoStateEnum;
  }

  public get isChargeTaxes(): boolean {
    return this.cargoPaymentsService.isChargeTaxes(this.cargo);
  }
  public get isChargeFopat(): boolean {
    return this.cargoPaymentsService.isChargeFopat(this.cargo);
  }

  public get hasFastPaymentEnabled(): boolean {
    return (this.authService && !!this.authService.getCompanySaaS() && !!this.authService.getCompanySaaS().fastPaymentEnabled) || this.utils.isTeclogiUserOrClient;
  }

  public async updateBalance() {
    const merged = this.mergedCargo;
    const balanceState = !!this.utils.getNestedValue(merged, 'shippingCost.balanceState');
    this.balance = balanceState
      ? this.cargoItemService.getCargoBalancePaid(merged)
      : await this.cargoPaymentsService.getBalance(merged, true, this.travelExpenses);
    // El saldo se calcula de forma asíncrona (await getBalance) — con OnPush hay que
    // marcar la vista para que la fila refleje el saldo tras resolver la promesa.
    this.cdRef.markForCheck();
  }

  public get canAccessTravelExpenses(): boolean {
    return this.authService.hasCompanySettingEnabled(SettingId.USE_TRAVEL_EXPENSES);
  }

  private async getTravelExpenses() {
    try {
      const result = await this.travelExpensesService.byCargoId(this.cargo.id).toPromise();
      this.travelExpenses = Array.isArray(result) ? result : [];
      this.travelExpensesLoaded = true;
    } catch (error) {
      this.travelExpenses = [];
    }
  }

  public async showLegalizeTravelExpensesDialog(): Promise<void> {
    this.spinner.show();
    const expenses = await this.getTravelExpenses();
    this.spinner.hide();
    const config = new MatDialogConfig();
    config.data = {
      cargo: this.cargo,
      travelExpenses: expenses
    }
    config.width = ModalEnum.LARGE_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    await this.dialogMat.open(LegalizeTravelExpensesComponent, config).afterClosed().toPromise();
    this.applyFilter.emit();
  }

  selectDriver(cargo: Cargo) {
    let route = "/cargo/applications";
    //sessionStorage.setItem("_lastList", this.typeList.toString());

    if (this.typeList === "loadsInNegotiation") {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiation = this.negotiation;
      this.navigate.emit("cargo/negotiation");
      this.router.navigate(["cargo/negotiation"]);
    } else if (this.typeList === "cargoRequestNegotiation") {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiationRequest = this.negotiationRequest;
      this.navigate.emit("cargo/negotiation");
      this.router.navigate(["cargo/negotiation"]);
    } else {
      this.authService.cargoActive.cargo = cargo;
      this.authService.cargoActive.negotiation = {
        state: null,
        driver: null,
        negotiatedValueDriver: null,
        negotiatedValueCreator: null,
      };
      this.navigate.emit("cargo/negotiation");
      this.router.navigate([route, cargo.consecutive]);
    }
  }

  get visualNumberOfOffers(): string {
    if (!this.cargo || !this.cargo.numberOfOffers || this.cargo.numberOfOffers <= 0) return null;
    if (this.cargo.numberOfOffers >= 100) return '+99';
    return `${this.cargo.numberOfOffers}`;
  }

  get showBells(): boolean {
    return CargoService.clickMadeToStartSounds;
  }

  get showAssignVehicleBtn(): boolean {
    if (!this.isTransportService) return false;
    const permissionSpecialLicensePlate = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.specialLicensePlate
    );
    const permissionAssignLicensePlate = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.assignLicensePlate
    );
    if (this.cargo && permissionSpecialLicensePlate && permissionAssignLicensePlate) return true;
    else if (permissionSpecialLicensePlate && this.cargo) return !this.cargo.licensePlate;
    else if (permissionAssignLicensePlate && this.cargo) {
      if (this.cargo.licensePlate) {
        return this.cargo.licensePlate !== "C0N111";
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  get canEditCargo(): boolean {
    return (CargoStateEnum.REQUEST === this.cargo.state || [this.cargoStateEnum.REQUEST].includes(this.cargo.requestState))
      && this.permissionRole.hasPermission(
        this.permission.cargo.module,
        this.permission.cargo.editCargo);
  }

  get alertsBadges(): Array<{ message: string, style: string }> {
    const alerts: Array<{ message: string, style: string }> = [];

    // Alerta de expiración de contenedor
    if (this.isLoadingRoutesTab && this.cargo && this.cargo.state === this.cargoStateEnum.START_SERVICE && (this.cargo.containerExpirationDate || this.containerType)) {
      let badgeClass = 'badge-light';
      let message = this.containerType;
      if (this.cargo && this.cargo.containerExpirationDate) {
        if (this.diffInDaysContainerExp <= this.expirationDateContainerEnum.RED_WARNING)
          badgeClass = 'badge-danger';
        else if (this.diffInDaysContainerExp === this.expirationDateContainerEnum.YELLOW_WARNING)
          badgeClass = 'badge-warning';
        else if (this.diffInDaysContainerExp >= this.expirationDateContainerEnum.GREEN_WARNING)
          badgeClass = 'badge-success';
        message += `: ${this.diffInDaysContainerExp} día${this.diffInDaysContainerExp !== 1 ? 's' : ''}`;
      }
      alerts.push({
        message: message,
        style: `alerts-expiration-date ${badgeClass}`
      });
    }

    const tripTypeDate = this.utils.getNestedValue(this.cargo, 'cargoModel.tripType.date');
    const tripTypeRegimeType = this.utils.getNestedValue(this.cargo, 'cargoModel.tripType.regimeType');
    // Alerta límite de cargue
    if (this.cargo && [this.cargoStateEnum.ACCEPTED, this.cargoStateEnum.CREATED].includes(this.cargo.state) &&
      tripTypeDate && ['DUTA', 'OTM', 'DTA'].includes(tripTypeRegimeType)) {

      let badgeClass = 'badge-success';
      let message = `Límite de cargue: ${this.expirationDaysDTAToLoad} día${this.expirationDaysDTAToLoad !== 1 ? 's' : ''}`;

      if (this.expirationDaysDTAToLoad <= this.ExpirationDateDTAEnum.RED_WARNING && this.expirationDaysDTAToLoad !== 0)
        badgeClass = 'badge-danger';
      else if (this.expirationDaysDTAToLoad === 0) {
        badgeClass = 'badge-danger';
        message = 'Límite de cargue: Hoy';
      } else if (this.expirationDaysDTAToLoad === this.ExpirationDateDTAEnum.YELLOW_WARNING)
        badgeClass = 'badge-warning';
      else if (this.expirationDaysDTAToLoad >= this.ExpirationDateDTAEnum.GREEN_WARNING)
        badgeClass = 'badge-success';

      alerts.push({
        message: message,
        style: `alerts-expiration-date-DTA ${badgeClass}`
      });
    }
    // Alerta límite de descargue
    if (this.isLoadingRoutesTab && this.cargo && this.cargo.state === this.cargoStateEnum.START_SERVICE && tripTypeDate && ['DUTA', 'OTM', 'DTA'].includes(tripTypeRegimeType)) {
      let badgeClass = 'badge-success';
      let message = `Límite de descargue: ${this.expirationDaysDTAToDownload} día${this.expirationDaysDTAToDownload !== 1 ? 's' : ''}`;
      if (this.expirationDaysDTAToDownload <= this.ExpirationDateDTAEnum.RED_WARNING && this.expirationDaysDTAToDownload !== 0)
        badgeClass = 'badge-danger';
      else if (this.expirationDaysDTAToDownload === 0) {
        badgeClass = 'badge-danger';
        message = 'Límite de descargue: Hoy';
      } else if (this.expirationDaysDTAToDownload === this.ExpirationDateDTAEnum.YELLOW_WARNING)
        badgeClass = 'badge-warning';
      alerts.push({
        message: message,
        style: `alerts-expiration-date-DTA ${badgeClass}`
      });
    }

    // Alerta de factura
    if (this.canAlertBill) {
      let badgeClass = 'badge-success';
      if (this.diffInDaysBillExp <= this.expirationBillEnum.BLACK_WARNING)
        badgeClass = 'badge-dark';
      else if (this.diffInDaysBillExp === this.expirationBillEnum.RED_WARNING)
        badgeClass = 'badge-danger';
      else if (this.diffInDaysBillExp === this.expirationBillEnum.YELLOW_WARNING)
        badgeClass = 'badge-warning';
      else if (this.diffInDaysBillExp >= this.expirationBillEnum.GREEN_WARNING)
        badgeClass = 'badge-success';

      alerts.push({
        message: `Factura: ${this.diffInDaysBillExp} día${this.diffInDaysBillExp !== 1 ? 's' : ''}`,
        style: `alerts-expiration-date ${badgeClass}`
      });
    }

    // Alerta fecha límite de pago al conductor
    if (this.cargo && [this.cargoStateEnum.START_SERVICE, this.cargoStateEnum.END_SERVICE, this.cargoStateEnum.ACCEPTED].includes(this.cargo.state) && this.canAlertDriverPayment) {
      let badgeClass = 'badge-success';
      if (this.diffInDaysDriverPayment <= this.expirationDriverPaymentEnum.BLACK_WARNING)
        badgeClass = 'badge-dark';
      else if (this.diffInDaysDriverPayment === this.expirationDriverPaymentEnum.RED_WARNING)
        badgeClass = 'badge-danger';
      else if (this.diffInDaysDriverPayment === this.expirationDriverPaymentEnum.YELLOW_WARNING)
        badgeClass = 'badge-warning';
      else if (this.diffInDaysDriverPayment >= this.expirationDriverPaymentEnum.GREEN_WARNING)
        badgeClass = 'badge-success';

      alerts.push({
        message: `Pago al conductor: ${this.diffInDaysDriverPayment} día${this.diffInDaysDriverPayment !== 1 ? 's' : ''}`,
        style: `alerts-expiration-date ${badgeClass}`
      });
    }

    // Alerta de error de generación de comprobante de pago
    if (this.cargo && this.cargoListService.canGenerateJournal(this.typeList) && this.cargo.journalError && this.cargo.journalError.hasError) {
      let badgeClass = 'badge-danger';
      alerts.push({
        message: `Error de generación de comprobante de pago`,
        style: `alerts-expiration-date ${badgeClass}`
      });
    }

    return alerts;
  }

  private subscribeToPayments(cargoId: string) {
    if (this.paymentsSubscription) {
      this.paymentsSubscription.unsubscribe();
      this.paymentsSubscription = null;
    }
    this.realtimePayments = [];
    this.paymentsSubscription = this.cargoPaymentsService.watchCargoPayments$(cargoId).subscribe(
      (payments) => {
        this.realtimePayments = payments;
        this.updateBalance(); // updateBalance() ya hace markForCheck()
      },
      () => { this.realtimePayments = []; this.cdRef.markForCheck(); }
    );
  }

  get mergedCargo(): Cargo {
    return this.cargoPaymentsService.getCargoWithMergedPayments(this.cargo, this.realtimePayments);
  }

  ngOnDestroy() {
    if (this.listenerId) this.cargoService.stopWatch(this.listenerId);
    if (this.cargoChangesSub) this.cargoChangesSub.unsubscribe();
    if (this.paymentsSubscription) this.paymentsSubscription.unsubscribe();
    if (this.transportCompaniesSubscription) this.transportCompaniesSubscription.unsubscribe();
  }

}
